/**
 * Секция Content Monitoring сообщает родителю (вкладке) своё состояние:
 * loading | error | empty | data.
 *
 * Это нужно, чтобы вкладка могла спрятать пустые блоки (у которых нет данных
 * под текущий фильтр) и, если пусты вообще все секции, показать один общий
 * текст «данных нет» вместо набора пустых панелей.
 *
 * Компонент, подключающий миксин, обязан:
 *   · иметь поля loading и error (они есть у всех секций CM);
 *   · определить computed `hasData` — есть ли что показывать.
 * Корень шаблона секции прячется при `cmSectionState === 'empty'`.
 *
 * До первого ответа API (cmSettled) секция считается loading, а не empty —
 * иначе при монтировании сразу мигает «данных нет».
 * После ответа без данных — сразу empty (не оставляем пустую оболочку панели).
 */
export default {
  data() {
    return {
      // в data, иначе Vue 2 не трекает смену: первый ответ «пусто»
      // (hasData false→false) не пересчитает cmSectionState и панель залипнет
      cmSettled: false,
    };
  },

  computed: {
    cmSectionState() {
      if (!this.cmSettled) return this.error ? "error" : "loading";
      if (this.error && !this.hasData) return "error";
      // после ответа: пусто = empty даже во время следующего silent/loading,
      // иначе мелькает панель-заголовок без содержимого
      if (!this.hasData) return this.error ? "error" : "empty";
      return "data";
    },
  },

  watch: {
    cmSectionState: {
      immediate: true,
      handler(state) {
        this.$emit("state", this.$options.name, state);
      },
    },
  },
};
